import { createRoute } from '@tanstack/react-router'
import { appShellRoute } from '@/app/routes/_appShell'
import { validateAnalyticsSearch } from '@/app/routes/_search'
import { AnalyticsPage } from '@/features/analytics/pages/AnalyticsPage'

export const analyticsRoute = createRoute({
  getParentRoute: () => appShellRoute,
  path: '/analytics',
  validateSearch: validateAnalyticsSearch,
  component: AnalyticsPage,
})
